import { sendGoogleEvent } from '@html/_common/utils';

export default function AMCommonMonthSelector(common) {
  const MONTH_CLASS = 'js-am-month-selector__month';
  const POPUP_CLASS = 'am-month-selector__popup';
  const ACTIVE_CLASS = 'am-month-selector__month--active';
  const HIDDEN_CLASS = 'hid';
  const VALID_CLASS = 'valid';

  this.common = {};

  if (typeof common !== 'undefined') {
    this.common = common;
  } else if (typeof sendGoogleEvent !== 'undefined') {
    this.common = {
      sendGoogleEvent,
    };
  }
  this.isInline = false;
  this.values = [];
  this.onMonthSelect = () => {};

  this.initiate = (options = {}) => {
    const {
      inline = false,
      allowMultiple = false,
      $container = $('body'),
      $input,
      gaCategory,
      onMonthSelect,
    } = options;
    if (onMonthSelect) {
      this.onMonthSelect = onMonthSelect;
    }
    this.allowMultiple = allowMultiple;
    this.initiateWrapper({ $container, inline });
    this.initiateField({ $input: $input || $container.find('.js-am-month-selector__input') });
    this.initiateMonths({ gaCategory });
    this.initiateYears();
  };

  this.isVisible = () => !this.$wrapper.hasClass(HIDDEN_CLASS);

  this.getValue = () => this.values.join(':');

  this.getText = () => this.$input.val();

  this.initiateWrapper = ({ $container, inline }) => {
    this.$wrapper = $container.find('.js-am-month-selector__wrapper');

    if (inline) {
      this.isInline = true;
      this.$wrapper.removeClass(POPUP_CLASS).removeClass(HIDDEN_CLASS);
    }
  };

  this.initiateField = ({ $input }) => {
    this.$input = $input;

    this.$input.on('click', (event) => {
      event.stopPropagation();

      if (this.$wrapper.hasClass(HIDDEN_CLASS)) {
        this.showMonths();
      } else {
        this.hideMonths();
      }
    });
  };

  this.initiateYears = () => {
    this.$currentYear = this.$wrapper.find('.js-am-month-selector__current-year');
    const initialYear = parseInt(this.$currentYear.text(), 10);

    this.minYear = this.$currentYear.data('min') || initialYear;
    this.maxYear = this.$currentYear.data('max') || initialYear;

    this.currentYear = initialYear;
    this.$prevYearButton = this.$wrapper.find('.js-am-month-selector__previous-year');
    this.$prevYearButton.on('click', this.goToPreviousYear);
    this.$nextYearButton = this.$wrapper.find('.js-am-month-selector__next-year');
    this.$nextYearButton.on('click', this.goToNextYear);
  };

  this.initiateMonths = ({
    gaCategory,
  }) => {
    this.$months = this.$wrapper.find(`.${MONTH_CLASS}`);
    const $preselectedMonth = $(`.${ACTIVE_CLASS}`);
    if ($preselectedMonth.length) {
      if (this.allowMultiple) {
        $preselectedMonth.each((idx, el) => {
          this.selectMonth($(el), true);
        });
      } else {
        this.selectMonth($preselectedMonth.first(), true);
      }
    }

    this.$months.find('button').on('click', (e) => {
      const $month = $(e.currentTarget).closest(`.${MONTH_CLASS}`);

      if ($month.hasClass(ACTIVE_CLASS)) {
        this.deselectMonth($month);
      } else {
        this.selectMonth($month);
        if (gaCategory) {
          this.common.sendGoogleEvent(gaCategory, 'Select Month', $month.data('value'));
        }
      }

      if (!this.isInline) {
        this.hideMonths();
      }
    });
  };

  this.deselectSelectedMonths = () => {
    this.$wrapper.find(`.${MONTH_CLASS}.${ACTIVE_CLASS}`).each((index, element) => {
      const $month = $(element);
      this.deselectMonth($month);
    });
  };

  this.selectMonth = ($month, preSelect = false) => {
    const value = $month.data('value');
    if (this.allowMultiple) {
      this.values.push(value);
    } else {
      this.values = [value];
      this.$months.removeClass(ACTIVE_CLASS);
    }
    $month.addClass(ACTIVE_CLASS);

    const label = $month.data('label');
    this.$input
      .val(this.allowMultiple ? this.getValue() : label)
      .trigger('change');
    this.$input.toggleClass(VALID_CLASS, this.values.length > 0);

    if (!preSelect) {
      this.onMonthSelect();
    }
  };

  this.deselectMonth = ($month) => {
    $month.removeClass(ACTIVE_CLASS);
    this.values = this.values.filter((v) => v !== $month.data('value'));
    this.$input
      .val(this.allowMultiple ? this.getValue() : '')
      .trigger('change');
    this.$input.toggleClass(VALID_CLASS, this.values.length > 0);
  };

  this.goToPreviousYear = () => {
    if (this.currentYear === this.minYear) {
      return;
    }
    this.currentYear -= 1;
    this.updateYear();
  };

  this.goToNextYear = () => {
    if (this.currentYear === this.maxYear) {
      return;
    }
    this.currentYear += 1;
    this.updateYear();
  };

  this.updateYear = () => {
    this.$months.each((idx, el) => {
      const $el = $(el);
      const year = parseInt($el.data('value').split('-')[1], 10);
      $el.toggleClass(HIDDEN_CLASS, year !== this.currentYear);
    });
    this.$currentYear.text(this.currentYear);
    this.$prevYearButton.prop('disabled', this.currentYear === this.minYear);
    this.$nextYearButton.prop('disabled', this.currentYear === this.maxYear);
  };

  this.checkOutsideMonthsClick = (event) => {
    const isMonthClicked = $(event.target).closest(`.${POPUP_CLASS}`).length > 0;
    if (isMonthClicked) {
      return false;
    }

    this.hideMonths();

    return true;
  };

  this.addOutsideMonthsClickListener = () => {
    $('body').on('click', this.checkOutsideMonthsClick);
  };

  this.removeOutsideMonthsClickListener = () => {
    $('body').off('click', this.checkOutsideMonthsClick);
  };

  this.showMonths = () => {
    this.$wrapper.removeClass(HIDDEN_CLASS);
    this.addOutsideMonthsClickListener();
  };

  this.hideMonths = () => {
    this.$wrapper.addClass(HIDDEN_CLASS);
    this.removeOutsideMonthsClickListener();
  };
}
